import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import { TemplatePart } from '../parts-list.component';
import { ConfigService } from 'src/app/shared/services/config.service';
import { FormControl, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { AddCurrencyPrefixDirective } from '../../../../../shared/directives/add-currency-prefix.directive';
import { MatInput } from '@angular/material/input';
import { MatFormField, MatLabel, MatPrefix, MatError } from '@angular/material/form-field';
import { NgIf } from '@angular/common';

@Component({
    selector: 'app-edit-part-dialog',
    templateUrl: './edit-part-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [MatDialogTitle, MatDialogContent, ReactiveFormsModule, NgIf, MatFormField, MatLabel, MatInput, MatPrefix, AddCurrencyPrefixDirective, MatError, MatDialogActions, MatButton, MatDialogClose]
})
export class EditPartDialogComponent {
  form = new FormGroup({
    name: new FormControl<string>(null),
    price: new FormControl<string>(null, Validators.required),
    quantity: new FormControl<number>(null, Validators.required)
  });

  availableTaxRates$ = this.configService.taxRates;
  title = 'Edit Item';
  freeText = false;
  addingFreeTextItem = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: TemplatePart,
    private matDialogRef: MatDialogRef<EditPartDialogComponent>,
    private configService: ConfigService
  ) {
    const { price, quantity, name, retail_product_id } = data;
    console.log(price);
    this.form.patchValue({
      name: name,
      price: price ? (price / 100).toFixed(2) : '0',
      quantity
    });
    this.freeTextEditingSetup(retail_product_id, name);
  }

  private freeTextEditingSetup(productId: number | null, name: string) {
    if (productId) {
      this.freeText = false;
      this.title = `Editing ${name}`;
      this.form.get('name').disable();
    } else {
      this.freeText = true;
      this.form.get('name').enable();
      this.title = 'Adding/Editing Freetext Item';
    }
  }

  save() {
    this.matDialogRef.close(this.form.value);
  }
}
